<template>
  <Modal 
    :id="'cmp-catalog-licence-add-account'" 
    @cancelled="onCancel"
  >
    <template slot="header"> </template>
    <template slot="body">
      <EditVatTerritoryDate 
        v-if="vatTerritoryData && vatTerritoryData!={}"
        :vatTerritoryData="vatTerritoryData"
        @change="onChange"
      />

      <EditVatTerritoryVatRates
         v-if="vatTerritoryData && vatTerritoryData!={}"
        :vatTerritoryData="vatTerritoryData"
        @add="onAddVatRate"
        @delete="onDeleteVatRate"
        @changed="onVatRateChange"
      />
      <EditVatTerritoryVatClass
         v-if="vatTerritoryData && vatTerritoryData!={}"
        :vatTerritoryData="vatTerritoryData"
        @add="onAddVatClass"
        @delete="onDeleteVatClass"
        @changed="onVatClassChange"
      />
   
    </template>
    <template slot="options">
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
         :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onOKClick"
      >
        {{$t('ok')}}
      </button>

    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { AccountingSettingsService } from '../../services/accounting-settings.service';
import EditVatTerritoryDate from './edit-vat-territory-date.vue';
import EditVatTerritoryVatRates from './edit-vat-territory-vat-rates.vue';
import EditVatTerritoryVatClass from './edit-vat-territory-vat-class.vue';
import { MHTTPCL } from '../../../../services/http/http-client';

export default {
  components: {
    Modal,
    EditVatTerritoryDate,
    EditVatTerritoryVatRates,
    EditVatTerritoryVatClass
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
      vatTerritoryData:{},
      licenceStatuses:[],
      validationResult: {},
    };
  },
  mounted:async function() {
    const modalData = await AccountingSettingsService.vatTerritoryEditModalData(this.vat_territory_id);

    console.log(":::",modalData,":::")

    this.vatTerritoryData=modalData.data
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    vat_territory_id: function() {
      //console.log(this.$route.params.vat_category_id,this.$route,';;;;;')
      return this.$route.query.vat_territory_id;
    }


  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.vatTerritoryObj[key]=value
    },
    onCancel: function() {
      console.log(":::")
      this.$emit("cancelled", true);
    },
    onOKClick: async function(e) {
      console.log()
      this.$emit('done', {...this.vatTerritoryObj});
    },
    onChange:function(payload){
      const {key,value,objKey} =payload
      console.log(":::::BEFORE::::::",this.vatTerritoryData);
      this.vatTerritoryData={
        ...this.vatTerritoryData,
        [objKey]:{
          ...this.vatTerritoryData[objKey],
          [key]:value,
        }

      }

      console.log(":::::AFTER::::::",this.vatTerritoryData);

      MHTTPCL.modifyJSON(null,this.vatTerritoryData[objKey].vat_territory_id,key,value,'vat_territories');
    },

    onAddVatRate:async function(){
      const vatTerritory = this.vatTerritoryData['vat_territory']
      const resVatRate = await AccountingSettingsService.addVatRate(vatTerritory.vat_territory);
      console.log(":::::",resVatRate,":::::");

      this.vatTerritoryData['vat_rates']=[...this.vatTerritoryData['vat_rates'],...resVatRate.data['vat_rates']]

      
    },

    onDeleteVatRate:function(item){

      const { vat_rate_id } =item;

      console.log("vat_rate_id",vat_rate_id)
      console.log(this.vatTerritoryData['vat_rates'])
      this.vatTerritoryData['vat_rates']=this.vatTerritoryData['vat_rates'].filter(e=>e.vat_rate_id!=vat_rate_id);
      AccountingSettingsService.deleteVatRate(vat_rate_id);

      


    },
    onVatRateChange:function({name,value,kVal,vat_class_name}){

      console.log({name,value,kVal,vat_class_name},"::::",vat_class_name!=undefined)
      this.vatTerritoryData['vat_rates']=this.vatTerritoryData['vat_rates'].map(e=>{
        if(e.vat_rate_id==kVal){
          return{
            ...e,
            [name]:value
          }
        }else{
          return e;
        }
      });
      if(vat_class_name==undefined){
        MHTTPCL.modifyJSON(null,kVal,name,value,'vat_rates');
      }else{
        AccountingSettingsService.modifyRecord(kVal,vat_class_name,value)
      }
      
    },


    onAddVatClass:async function(){
      const vatTerritory = this.vatTerritoryData['vat_territory']
      const resVatRate = await AccountingSettingsService.addVatClass(vatTerritory.vat_territory);
      console.log(":::::",resVatRate,":::::");

      this.vatTerritoryData['vat_classes']=[...this.vatTerritoryData['vat_classes'],...resVatRate.data['vat_classes']]
    },


    onDeleteVatClass:function(item){

      const { vat_class_id } =item;

      console.log("vat_class_id",vat_class_id)
      console.log(this.vatTerritoryData['vat_classes'])
      this.vatTerritoryData['vat_classes']=this.vatTerritoryData['vat_classes'].filter(e=>e.vat_class_id!=vat_class_id);
      AccountingSettingsService.deleteVatClass(vat_class_id);

      


    },

    onVatClassChange:function({name,value,kVal}){
      this.vatTerritoryData['vat_classes']=this.vatTerritoryData['vat_classes'].map(e=>{
        if(e.vat_class_id==kVal){
          return{
            ...e,
            [name]:value
          }
        }else{
          return e;
        }
      });
      MHTTPCL.modifyJSON(null,kVal,name,value,'vat_classes');

      //MHTTPCL.modifyRecord()
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>